var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1167(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Group_1167",
    "data-name": "Group 1167",
    width: 613.119,
    height: 553.4,
    viewBox: "0 0 613.119 553.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 613.119,
    height: 553.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 603.126,
    height: 523.623,
    transform: "translate(9.493)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 165.194,
    height: 63.46,
    transform: "translate(126.871 363.986)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 260.185,
    height: 54.5,
    transform: "translate(254.204 148.489)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M385.712,478.342a24.876,24.876,0,0,0-3.46,2.239c-12.84,10.011-4.51,26.571-1.12,31.58,3.66,5.41,57.62,30.96,76.36,31.441s53.1-4.69,59.87-15.721-.17-23.28-9.57-32.259a13.9,13.9,0,0,0-3.06-2.221c-6-3.248-14.015-2.307-20.735-1.368-4.555.638-8.515,1.275-10.845.608-8.27-2.35-11.16-5.649-15.24-6.169-1.33-.171-4.95,2.119-4.95,2.119s-43.554-11.183-61.127-11.182c-2.786,0-4.92.281-6.123.933",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 122.48,
    height: 43.063,
    transform: "translate(382.252 477.409)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M448.114,537.439l17.516,13.749a200.63,200.63,0,0,0,25.117-3.754l0-.009c8.3-1.922,15.549-4.677,15.947-8.454.606-5.741-5.53-7.313-12.824-7.09-1.362.031-2.76.136-4.17.283-11.673,1.252-26.509-5.2-26.509-5.2Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    width: 58.621,
    height: 20.319,
    transform: "translate(448.11 526.968)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M464.442,542.858c-3.158.515.313,6.974,4.593,5.012,4-1.832-.722-5.062-3.936-5.062a4.1,4.1,0,0,0-.657.05",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 7.344,
    height: 4.021,
    transform: "translate(463.222 542.808)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M493.872,531.881c-.319.306-7.388,7.143-3.123,15.544,8.3-1.922,15.549-4.677,15.947-8.454.57-5.4-4.821-7.11-11.529-7.11q-.641,0-1.295.02",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    width: 17.34,
    height: 14.065,
    transform: "translate(489.391 531.862)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M396.539,528.355c-1.387-.295-2.766-.546-4.118-.719-7.23-.989-13.5-.07-13.5,5.7,0,3.8,6.919,7.3,14.972,10.082v.009a200.571,200.571,0,0,0,24.584,6.371l18.864-11.833-13.9-12s-15.43,4.854-26.907,2.383",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_340",
    "data-name": "Rectangle 340",
    width: 33.626,
    height: 18.959,
    transform: "translate(403.717 525.971)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 32.062,
    height: 116.908,
    transform: "translate(186.025 349.26)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 164.3,
    height: 79.07,
    transform: "translate(149.73 413.4)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 203.41,
    height: 61.52,
    transform: "translate(304.269 110.28)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M594.956,321.382c-19.11,49.555-58.157,103.188-113.1,119.068-83.022,24-92.94,88.79-241.642,82.781a309.25,309.25,0,0,1-64.3-9.129,255.643,255.643,0,0,1-30.232-9.736C58.807,470.3,13.491,395.326,9.729,316.878,4.763,213.7,79.121,164.523,127.446,135.727S234.017-4.646,380.248.15A299.647,299.647,0,0,1,446.342,9.5c49.2,12.893,99.222,41.409,128.288,83.1q3.273,4.7,6.257,9.6c38.9,63.892,40.125,151.627,14.069,219.185",
    fill: "#ff6d0c"
  })))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x1: 97.885,
    transform: "translate(32.296 537.747)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x1: 448.324,
    transform: "translate(164.295 537.747)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M587.544,139.01V437.43a28.743,28.743,0,0,1-28.74,28.74H51.554a28.743,28.743,0,0,1-28.74-28.74V139.01a28.735,28.735,0,0,1,28.74-28.73H558.8a28.735,28.735,0,0,1,28.74,28.73",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M587.544,139.01V437.43a28.743,28.743,0,0,1-28.74,28.74H51.554a28.743,28.743,0,0,1-28.74-28.74V139.01a28.735,28.735,0,0,1,28.74-28.73H558.8A28.735,28.735,0,0,1,587.544,139.01Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M108.922,117.551H65.058a17.583,17.583,0,0,0-17.583,17.583V441.31a17.583,17.583,0,0,0,17.583,17.583h43.864Z",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M578.716,288.222a16.43,16.43,0,1,1-16.43-16.43,16.43,16.43,0,0,1,16.43,16.43",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M35.764,329.012h0a2.563,2.563,0,0,1-2.556-2.556V249.988a2.556,2.556,0,0,1,5.112,0v76.468a2.563,2.563,0,0,1-2.556,2.556",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M520.523,117.551H107.97c-8.827,0-15.983,7.872-15.983,17.583V441.31c0,9.711,7.156,17.583,15.983,17.583H520.523c8.826,0,15.982-7.872,15.982-17.583V135.134c0-9.711-7.156-17.583-15.982-17.583",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M84.352,188.462a14.527,14.527,0,1,1-14.527-14.527,14.527,14.527,0,0,1,14.527,14.527",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M68.258,194.756v-4.7h3.134v4.7h3.917v-6.267h2.35l-7.834-7.051-7.834,7.051h2.35v6.267Z",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M64.481,151.458H75.17V150.27H64.481Zm0-2.969H75.17V147.3H64.481Zm0-2.969H75.17v-1.188H64.481Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M75.62,225.617H70.271l-1.783-1.783H64.031a1.338,1.338,0,0,0-1.338,1.337V233.2a1.338,1.338,0,0,0,1.338,1.337H75.62a1.337,1.337,0,0,0,1.337-1.337v-6.241a1.337,1.337,0,0,0-1.337-1.337",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M76.957,309.574a1.328,1.328,0,0,0-.645-1.155l-6.487-3.228-6.487,3.228a1.406,1.406,0,0,0-.645,1.155v6.484a1.362,1.362,0,0,0,1.359,1.359H75.6a1.362,1.362,0,0,0,1.359-1.359Zm-7.132,3.258-5.456-3.566,5.456-2.717,5.456,2.717Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M76.533,271.108H70.311l4.144,4.144a.42.42,0,0,0,.581.018,6.277,6.277,0,0,0,1.918-3.692.421.421,0,0,0-.368-.467.475.475,0,0,0-.053,0m-.414-1.7a6.308,6.308,0,0,0-5.853-5.853.422.422,0,0,0-.44.4v5.89h5.867a.421.421,0,0,0,.426-.417v-.023m-7.552,1.7v-6.222a.421.421,0,0,0-.417-.424l-.049,0a6.29,6.29,0,0,0-5.4,6.444,6.372,6.372,0,0,0,6.369,6.074,6.252,6.252,0,0,0,3.547-1.156.417.417,0,0,0,.083-.584.483.483,0,0,0-.042-.048Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M505.518,442.7H332.529a12.035,12.035,0,0,1-12-12v-82.35a12.035,12.035,0,0,1,12-12H505.518a12.035,12.035,0,0,1,12,12V430.7a12.035,12.035,0,0,1-12,12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M295.962,324.283H122.973a12.035,12.035,0,0,1-12-12v-82.35a12.035,12.035,0,0,1,12-12H295.962a12.035,12.035,0,0,1,12,12v82.35a12.035,12.035,0,0,1-12,12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M225.85,205.871H122.973a12.035,12.035,0,0,1-12-12v-48.6a12.035,12.035,0,0,1,12-12H225.85a12.035,12.035,0,0,1,12,12v48.6a12.035,12.035,0,0,1-12,12",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M191.822,261.288a23.838,23.838,0,1,1-23.838-23.838A23.838,23.838,0,0,1,191.822,261.288Z",
    fill: "none",
    stroke: "#eeebef",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M191.822,261.288a23.838,23.838,0,1,1-23.838-23.838",
    fill: "none",
    stroke: "#ff6d0c",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M192.257,301.994H143.466a2.994,2.994,0,1,1,0-5.989h48.791a2.994,2.994,0,1,1,0,5.989",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M181.931,309.035H153.793a1.848,1.848,0,1,1,0-3.7h28.138a1.848,1.848,0,1,1,0,3.7",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M275.035,261.288A23.838,23.838,0,1,1,251.2,237.45,23.838,23.838,0,0,1,275.035,261.288Z",
    fill: "none",
    stroke: "#eeebef",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M267.642,278.544A23.838,23.838,0,1,1,251.2,237.45",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M275.47,301.994H226.679a2.994,2.994,0,1,1,0-5.989H275.47a2.994,2.994,0,1,1,0,5.989",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M265.143,309.035H237.005a1.848,1.848,0,1,1,0-3.7h28.138a1.848,1.848,0,1,1,0,3.7",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M220.987,162.6H168.274a2.7,2.7,0,0,1,0-5.394h52.713a2.7,2.7,0,1,1,0,5.394",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M172.981,172.269h-4.707a2.7,2.7,0,0,1,0-5.394h4.707a2.7,2.7,0,0,1,0,5.394",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M220.987,172.269H182.428a2.7,2.7,0,0,1,0-5.394h38.559a2.7,2.7,0,1,1,0,5.394",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M196.866,181.933H168.275a2.7,2.7,0,0,1,0-5.394h28.591a2.7,2.7,0,1,1,0,5.394",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M157.265,169.572a16.152,16.152,0,1,1-16.152-16.152,16.151,16.151,0,0,1,16.152,16.152",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M517.518,205.871H251.2v-72.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x2: 2,
    transform: "translate(251.197 189.157)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 256.268,
    transform: "translate(257.233 189.157)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: "4.036 4.036"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 2,
    transform: "translate(515.518 189.157)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 2,
    transform: "translate(251.197 170.416)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x2: 256.268,
    transform: "translate(257.233 170.416)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: "4.036 4.036"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 2,
    transform: "translate(515.518 170.416)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 2,
    transform: "translate(251.197 151.675)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 256.268,
    transform: "translate(257.233 151.675)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: "4.036 4.036"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 2,
    transform: "translate(515.518 151.675)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M384.283,192.544c-8.114,0-11.738-6.618-15.243-13.018-2.893-5.284-5.882-10.743-10.776-10.743-5.475,0-8.158,2.131-11.266,4.6-3.385,2.688-7.218,5.732-14.75,5.732-8.258,0-11.685-8.026-15.313-16.522-2.79-6.542-5.954-13.953-10.7-13.953s-7.909,7.41-10.7,13.948c-3.628,8.5-7.054,16.527-15.314,16.527-7.777,0-11.615-4.268-15-8.033-3.1-3.45-5.784-6.43-11.016-6.43v-.8c5.567,0,8.355,3.1,11.58,6.684,3.279,3.647,6.995,7.779,14.436,7.779,7.757,0,11.085-7.8,14.607-16.05,2.887-6.763,6.157-14.426,11.406-14.426s8.521,7.664,11.408,14.426c3.523,8.255,6.85,16.05,14.607,16.05,7.27,0,10.993-2.957,14.278-5.565,3.222-2.559,6-4.766,11.738-4.766,5.344,0,8.445,5.664,11.445,11.143,3.4,6.205,6.91,12.617,14.574,12.617,7.636,0,11.155-6.008,14.556-11.82,3.129-5.343,6.084-10.39,11.455-10.39,5.551,0,8.339,3.208,11.567,6.924,3.28,3.777,6.995,8.055,14.454,8.055,7.782,0,11.1-8.306,14.619-17.1,2.9-7.24,6.174-15.442,11.4-15.442,5.3,0,8.418,6.3,11.43,12.4,3.387,6.858,6.888,13.945,14.6,13.945,7.442,0,11.16-4.132,14.439-7.779,3.228-3.586,6.016-6.684,11.586-6.684v.8c-5.236,0-7.915,2.98-11.02,6.43-3.388,3.765-7.227,8.033-15.005,8.033-8.179,0-11.79-7.309-15.282-14.377-2.907-5.884-5.91-11.966-10.744-11.966-4.713,0-7.888,7.94-10.689,14.945-3.618,9.051-7.035,17.6-15.333,17.6-7.8,0-11.64-4.419-15.025-8.317-3.106-3.576-5.789-6.663-11-6.663-4.936,0-7.782,4.861-10.8,10.006-3.513,6-7.146,12.205-15.216,12.205",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M309.255,148.317a2.9,2.9,0,1,1-2.9-2.9,2.9,2.9,0,0,1,2.9,2.9",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M387.2,192.155a2.9,2.9,0,1,1-2.9-2.9,2.9,2.9,0,0,1,2.9,2.9",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M465.239,152.544a2.9,2.9,0,1,1-2.9-2.9,2.9,2.9,0,0,1,2.9,2.9",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M505.518,324.283H332.529a12.035,12.035,0,0,1-12-12v-82.35a12.035,12.035,0,0,1,12-12H505.518a12.035,12.035,0,0,1,12,12v82.35a12.035,12.035,0,0,1-12,12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M340.379,309.035H344a3.952,3.952,0,0,0,3.952-3.952V295.75A3.951,3.951,0,0,0,344,291.8h-3.62a3.952,3.952,0,0,0-3.952,3.951v9.333a3.952,3.952,0,0,0,3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M357.472,309.035h3.62a3.952,3.952,0,0,0,3.952-3.952V266.458a3.952,3.952,0,0,0-3.952-3.952h-3.62a3.952,3.952,0,0,0-3.952,3.952v38.625a3.952,3.952,0,0,0,3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M374.565,309.035h3.62a3.952,3.952,0,0,0,3.952-3.952V286.442a3.951,3.951,0,0,0-3.952-3.951h-3.62a3.952,3.952,0,0,0-3.952,3.951v18.641a3.952,3.952,0,0,0,3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M391.658,309.035h3.62a3.952,3.952,0,0,0,3.952-3.952V266.458a3.952,3.952,0,0,0-3.952-3.952h-3.62a3.952,3.952,0,0,0-3.952,3.952v38.625a3.952,3.952,0,0,0,3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M408.752,309.035h3.62a3.952,3.952,0,0,0,3.952-3.952V282.144a3.952,3.952,0,0,0-3.952-3.952h-3.62a3.953,3.953,0,0,0-3.952,3.952v22.939a3.952,3.952,0,0,0,3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M425.845,309.035h3.62a3.952,3.952,0,0,0,3.952-3.952V249.527a3.952,3.952,0,0,0-3.952-3.952h-3.62a3.953,3.953,0,0,0-3.952,3.952v55.556a3.952,3.952,0,0,0,3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M438.987,258.644v46.44a3.952,3.952,0,0,0,3.952,3.952h3.62a3.952,3.952,0,0,0,3.951-3.952v-46.44a3.952,3.952,0,0,0-3.951-3.952h-3.62a3.952,3.952,0,0,0-3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M459.863,309.035h3.62a3.952,3.952,0,0,0,3.952-3.952V282.144a3.953,3.953,0,0,0-3.952-3.952h-3.62a3.953,3.953,0,0,0-3.952,3.952v22.939a3.952,3.952,0,0,0,3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M476.956,309.035h3.62a3.952,3.952,0,0,0,3.952-3.952V249.527a3.952,3.952,0,0,0-3.952-3.952h-3.62A3.953,3.953,0,0,0,473,249.527v55.556a3.952,3.952,0,0,0,3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M490.1,258.644v46.44a3.952,3.952,0,0,0,3.952,3.952h3.62a3.952,3.952,0,0,0,3.951-3.952v-46.44a3.952,3.952,0,0,0-3.951-3.952h-3.62a3.952,3.952,0,0,0-3.952,3.952",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M295.962,442.693H122.973a12.035,12.035,0,0,1-12-12v-82.35a12.035,12.035,0,0,1,12-12H295.962a12.035,12.035,0,0,1,12,12v82.35a12.035,12.035,0,0,1-12,12",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M288.113,427.446h-3.62a3.952,3.952,0,0,1-3.952-3.952v-9.333a3.952,3.952,0,0,1,3.952-3.951h3.62a3.952,3.952,0,0,1,3.952,3.951v9.333a3.952,3.952,0,0,1-3.952,3.952",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M271.02,427.446H267.4a3.952,3.952,0,0,1-3.952-3.952V384.869a3.952,3.952,0,0,1,3.952-3.952h3.62a3.952,3.952,0,0,1,3.952,3.952v38.625a3.952,3.952,0,0,1-3.952,3.952",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M253.927,427.446h-3.62a3.952,3.952,0,0,1-3.952-3.952V404.853a3.951,3.951,0,0,1,3.952-3.951h3.62a3.952,3.952,0,0,1,3.952,3.951v18.641a3.952,3.952,0,0,1-3.952,3.952",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M236.834,427.446h-3.62a3.952,3.952,0,0,1-3.952-3.952V384.869a3.952,3.952,0,0,1,3.952-3.952h3.62a3.952,3.952,0,0,1,3.952,3.952v38.625a3.952,3.952,0,0,1-3.952,3.952",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M219.74,427.446h-3.62a3.952,3.952,0,0,1-3.952-3.952V400.555a3.952,3.952,0,0,1,3.952-3.952h3.62a3.953,3.953,0,0,1,3.952,3.952v22.939a3.952,3.952,0,0,1-3.952,3.952",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M202.647,427.446h-3.62a3.952,3.952,0,0,1-3.952-3.952V367.938a3.952,3.952,0,0,1,3.952-3.952h3.62a3.953,3.953,0,0,1,3.952,3.952v55.556a3.952,3.952,0,0,1-3.952,3.952",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M189.505,377.054v46.44a3.952,3.952,0,0,1-3.952,3.952h-3.62a3.952,3.952,0,0,1-3.951-3.952v-46.44a3.952,3.952,0,0,1,3.951-3.952h3.62a3.952,3.952,0,0,1,3.952,3.952",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M168.629,427.446h-3.62a3.952,3.952,0,0,1-3.952-3.952V400.555a3.952,3.952,0,0,1,3.952-3.952h3.62a3.953,3.953,0,0,1,3.952,3.952v22.939a3.952,3.952,0,0,1-3.952,3.952",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M151.536,427.446h-3.62a3.952,3.952,0,0,1-3.952-3.952V367.938a3.952,3.952,0,0,1,3.952-3.952h3.62a3.953,3.953,0,0,1,3.952,3.952v55.556a3.952,3.952,0,0,1-3.952,3.952",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M138.394,377.054v46.44a3.952,3.952,0,0,1-3.952,3.952h-3.62a3.952,3.952,0,0,1-3.951-3.952v-46.44a3.952,3.952,0,0,1,3.951-3.952h3.62a3.952,3.952,0,0,1,3.952,3.952",
    fill: "#ff6d0c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M492.926,360.922H444.039a2.947,2.947,0,0,0-2.947,2.947v.1a2.947,2.947,0,0,0,2.947,2.947h48.887a2.946,2.946,0,0,0,2.947-2.947v-.1a2.946,2.946,0,0,0-2.947-2.947",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M444.039,380.41h30.1a2.947,2.947,0,0,0,2.947-2.947v-.1a2.947,2.947,0,0,0-2.947-2.947h-30.1a2.946,2.946,0,0,0-2.947,2.947v.1a2.946,2.946,0,0,0,2.947,2.947",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M444.039,393.909h41.5a2.946,2.946,0,0,0,2.946-2.947v-.1a2.946,2.946,0,0,0-2.946-2.947h-41.5a2.946,2.946,0,0,0-2.947,2.947v.1a2.946,2.946,0,0,0,2.947,2.947",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M492.926,401.418H444.039a2.947,2.947,0,0,0-2.947,2.947v.1a2.947,2.947,0,0,0,2.947,2.947h48.887a2.946,2.946,0,0,0,2.947-2.947v-.1a2.946,2.946,0,0,0-2.947-2.947",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M464.177,414.917H444.039a2.947,2.947,0,0,0-2.947,2.947v.1a2.947,2.947,0,0,0,2.947,2.947h20.138a2.946,2.946,0,0,0,2.947-2.947v-.1a2.946,2.946,0,0,0-2.947-2.947",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M431.687,360.922a2.881,2.881,0,0,0-2.881,2.881v.227a2.881,2.881,0,1,0,5.762,0V363.8a2.881,2.881,0,0,0-2.881-2.881",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M431.687,374.421a2.881,2.881,0,0,0-2.881,2.881v.227a2.881,2.881,0,1,0,5.762,0V377.3a2.881,2.881,0,0,0-2.881-2.881",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M431.687,387.919a2.881,2.881,0,0,0-2.881,2.881v.227a2.881,2.881,0,0,0,5.762,0V390.8a2.881,2.881,0,0,0-2.881-2.881",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M431.687,401.418a2.881,2.881,0,0,0-2.881,2.881v.227a2.881,2.881,0,1,0,5.762,0V404.3a2.881,2.881,0,0,0-2.881-2.881",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M431.687,414.917a2.881,2.881,0,0,0-2.881,2.881v.227a2.881,2.881,0,1,0,5.762,0V417.8a2.881,2.881,0,0,0-2.881-2.881",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 31.893,
    cy: 31.893,
    r: 31.893,
    transform: "translate(342.188 357.939)",
    fill: "none",
    stroke: "#eeebef",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M405.974,389.832a31.893,31.893,0,1,1-31.893-31.893",
    fill: "none",
    stroke: "#ff6d0c",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M391.92,390.264H356.243a2.947,2.947,0,0,0-2.947,2.947v.1a2.947,2.947,0,0,0,2.947,2.947H391.92a2.946,2.946,0,0,0,2.947-2.947v-.1a2.946,2.946,0,0,0-2.947-2.947",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M384.76,400.879H363.4a2.947,2.947,0,0,0-2.947,2.947v.1a2.947,2.947,0,0,0,2.947,2.947H384.76a2.946,2.946,0,0,0,2.947-2.947v-.1a2.946,2.946,0,0,0-2.947-2.947",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M382.24,377.128a8.158,8.158,0,1,1-8.158-8.158,8.158,8.158,0,0,1,8.158,8.158",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M254.2,202.989V164.5c5.568,0,8.354,3.1,11.58,6.684,3.279,3.647,6.995,7.779,14.437,7.779,7.757,0,11.084-7.795,14.606-16.049,2.887-6.763,6.157-14.426,11.406-14.426s8.522,7.664,11.408,14.426c3.523,8.255,6.85,16.049,14.607,16.049,7.27,0,10.993-2.957,14.278-5.565,3.222-2.558,6-4.766,11.738-4.766,5.344,0,8.446,5.665,11.445,11.143,3.4,6.206,6.91,12.618,14.573,12.618,7.637,0,11.155-6.009,14.557-11.82,3.129-5.344,6.085-10.391,11.456-10.391,5.55,0,8.338,3.209,11.566,6.925,3.28,3.777,7,8.054,14.455,8.054,7.782,0,11.1-8.306,14.618-17.1,2.9-7.239,6.175-15.441,11.4-15.441,5.3,0,8.419,6.3,11.431,12.4,3.387,6.857,6.887,13.944,14.6,13.944,7.442,0,11.16-4.132,14.44-7.778,3.227-3.587,6.014-6.685,11.585-6.685v38.487Z",
    fill: "#ff6d0c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M363.82,327.1c-5.285.452-12.012-5.869-12.012-5.869a1.182,1.182,0,0,1-1.888-.241c-.859-1.235-4.588-4.1-4.8-6.585s4.194-6.5,4.194-6.5c-3.4.927-3.756-1.064-3.756-1.064s5.711-4.716,7.708-4.842c.782-.05,4.188,1.907,7.476,4.552,3.44,2.767,9.9,12.519,9.9,12.519s21.854,15.868,27.378,19.931c7.287,5.361,15.925,14.867,15.925,14.867s29.021,13.078,36.977,20.266l-10.813,25.624S413.732,382.082,411.1,377.6s-5.275-1.786-7.912-4.718-5.166-6.279-5.166-6.279a44.635,44.635,0,0,1-12.551-9.125c-6.168-6.329-11.6-16.01-15.006-21.812a36.072,36.072,0,0,0-6.64-8.568",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M363.82,327.1c-5.285.452-12.012-5.869-12.012-5.869a1.182,1.182,0,0,1-1.888-.241c-.859-1.235-4.588-4.1-4.8-6.585s4.194-6.5,4.194-6.5c-3.4.927-3.756-1.064-3.756-1.064s5.711-4.716,7.708-4.842c.782-.05,4.188,1.907,7.476,4.552,3.44,2.767,9.9,12.519,9.9,12.519s21.854,15.868,27.378,19.931c7.287,5.361,15.925,14.867,15.925,14.867s29.021,13.078,36.977,20.266l-10.813,25.624S413.732,382.082,411.1,377.6s-5.275-1.786-7.912-4.718-5.166-6.279-5.166-6.279a44.635,44.635,0,0,1-12.551-9.125c-6.168-6.329-11.6-16.01-15.006-21.812A36.072,36.072,0,0,0,363.82,327.1Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M365.432,323.357s-7.865-1.906-8.549-7.1a9.624,9.624,0,0,0-1.689-3.629s-7.346-.363-6.879-3.353l9.794-.865a17.064,17.064,0,0,1,8.537,7.176",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M365.432,323.357s-7.865-1.906-8.549-7.1a9.624,9.624,0,0,0-1.689-3.629s-7.346-.363-6.879-3.353l9.794-.865a17.064,17.064,0,0,1,8.537,7.176",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M351.808,321.228a3.187,3.187,0,0,0,.331-2.12s2.16-.391,1.92-2.306c0,0,3.2-.393,1.135-4.171",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M354.058,316.8s-4.3-3.2-4.791-4.649",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M352.139,319.108s-4.587-2.792-4.668-4.431",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M353.187,304.728s-1.457,2.623-3.871,3.171",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M352.463,305.756a12.607,12.607,0,0,1,2.159,1.428",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M520.067,394.323a235.4,235.4,0,0,0-34.9-11.66c-17.567-4.115-45.961-7.781-45.961-7.781s7.817,79.8,5.759,84.6-14.421,20.92-14.421,20.92,66.892,26.08,78.552,28.3,5.578-38.247,5.578-38.247,12.251-51.441,5.394-76.133",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M496.062,385.751s1.59,3.03-2.59,4.57c-10.83,4-22.37.47-21.14-3.77.47-1.62,3.15,0,2.98-6.05a7.369,7.369,0,0,0-.73-2.66,27.47,27.47,0,0,0-2.75-4.61,57.26,57.26,0,0,0-3.71-4.63s17.19-10.97,29.94,0c0,0-4.74,2.4-2,17.15",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M496.062,385.751s1.59,3.03-2.59,4.57c-10.83,4-22.37.47-21.14-3.77.47-1.62,3.15,0,2.98-6.05a7.369,7.369,0,0,0-.73-2.66,27.47,27.47,0,0,0-2.75-4.61,57.26,57.26,0,0,0-3.71-4.63s17.19-10.97,29.94,0C498.062,368.6,493.322,371,496.062,385.751Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M517.362,527.881c-6.77,11.03-41.12,16.21-59.87,15.72s-72.7-26.03-76.36-31.44c-3.39-5.01-11.72-21.57,1.12-31.58a24.879,24.879,0,0,1,3.46-2.24c8.79-4.76,67.25,10.25,67.25,10.25s3.62-2.29,4.95-2.12c4.08.52,6.97,3.82,15.24,6.17,5.77,1.65,21.52-4.69,31.58.76a13.877,13.877,0,0,1,3.06,2.22c9.4,8.98,16.33,21.23,9.57,32.26",
    fill: "#ff6d0c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M504.732,493.4c-10.31-.69-19.5,1.47-25.92,5.26-7.61,4.5-43.55,21.81-43.55,21.81.08-1.86,2.08-5.61,2.08-5.61-3.38-3.01-12.22-5.35-12.22-5.35-6.85-5.85-34.03-23.3-42.87-28.93a24.879,24.879,0,0,1,3.46-2.24c8.79-4.76,67.25,10.25,67.25,10.25s3.62-2.29,4.95-2.12c4.08.52,6.97,3.82,15.24,6.17,5.77,1.65,21.52-4.69,31.58.76"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M517.362,527.881c-6.77,11.03-41.12,16.21-59.87,15.72s-72.7-26.03-76.36-31.44c-3.39-5.01-11.72-21.57,1.12-31.58a24.879,24.879,0,0,1,3.46-2.24c8.79-4.76,67.25,10.25,67.25,10.25s3.62-2.29,4.95-2.12c4.08.52,6.97,3.82,15.24,6.17,5.77,1.65,21.52-4.69,31.58.76a13.877,13.877,0,0,1,3.06,2.22C517.192,504.6,524.122,516.851,517.362,527.881Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M506.817,537.837l.864,3.77s-2.3,6.527-12.412,7.591-16.1,3.306-20.956,3.6a41.552,41.552,0,0,1-7.689-.122l-.992-1.485Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M506.817,537.837l.864,3.77s-2.3,6.527-12.412,7.591-16.1,3.306-20.956,3.6a41.552,41.552,0,0,1-7.689-.122l-.992-1.485Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M448.114,537.439l17.516,13.749a200.427,200.427,0,0,0,25.118-3.754v-.009c8.3-1.921,15.549-4.678,15.947-8.454.607-5.741-5.53-7.313-12.823-7.09-1.363.031-2.76.136-4.171.283-11.673,1.252-26.509-5.2-26.509-5.2Z",
    fill: "#4e3057"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M506.7,538.845a53.9,53.9,0,0,0-9.744,4.794s-16.271,8.374-41.272-.252l-7.577-5.946,15.084-10.472s14.832,6.449,26.509,5.192c1.413-.147,2.809-.251,4.17-.277,7.239-.226,13.333,1.318,12.83,6.961"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M448.114,537.439l17.516,13.749a200.427,200.427,0,0,0,25.118-3.754v-.009c8.3-1.921,15.549-4.678,15.947-8.454.607-5.741-5.53-7.313-12.823-7.09-1.363.031-2.76.136-4.171.283-11.673,1.252-26.509-5.2-26.509-5.2Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M464.443,542.858c-3.158.515.312,6.974,4.593,5.012s-1.435-5.527-4.593-5.012",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M470.371,546.829a67.184,67.184,0,0,1-6.8-1.188c-.607-1.265-.468-2.566.876-2.782,2.652-.434,7.108,2.011,5.929,3.97"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M464.443,542.858c-3.158.515.312,6.974,4.593,5.012S467.6,542.343,464.443,542.858Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M490.749,547.425c8.3-1.921,15.548-4.678,15.947-8.454.607-5.741-5.53-7.313-12.823-7.09-.32.306-7.389,7.144-3.124,15.544",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M506.7,538.845a53.9,53.9,0,0,0-9.744,4.794,32.782,32.782,0,0,1-6.848,2.288c-2.8-7.7,3.459-13.757,3.762-14.043,7.239-.226,13.333,1.318,12.83,6.961"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M490.749,547.425c8.3-1.921,15.548-4.678,15.947-8.454.607-5.741-5.53-7.313-12.823-7.09C493.553,532.187,486.484,539.025,490.749,547.425Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M484.829,540.295l.05,0a.867.867,0,0,0,.908-.824,11.725,11.725,0,0,1,2.986-6.592.867.867,0,0,0-1.25-1.2,13.314,13.314,0,0,0-3.468,7.71.867.867,0,0,0,.774.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M484.829,540.295l.05,0a.867.867,0,0,0,.908-.824,11.725,11.725,0,0,1,2.986-6.592.867.867,0,0,0-1.25-1.2,13.314,13.314,0,0,0-3.468,7.71A.867.867,0,0,0,484.829,540.295Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M481.358,540.5a.613.613,0,0,0,.074,0,.865.865,0,0,0,.884-.849,12.841,12.841,0,0,1,2.654-6.854.867.867,0,0,0-1.34-1.1,14.383,14.383,0,0,0-3.047,7.918.868.868,0,0,0,.775.88",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M481.358,540.5a.613.613,0,0,0,.074,0,.865.865,0,0,0,.884-.849,12.841,12.841,0,0,1,2.654-6.854.867.867,0,0,0-1.34-1.1,14.383,14.383,0,0,0-3.047,7.918A.868.868,0,0,0,481.358,540.5Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M477.209,540.064l.015,0a.869.869,0,0,0,.94-.788c.266-3.038,2.851-6.922,2.877-6.961a.867.867,0,0,0-1.44-.967c-.117.174-2.859,4.291-3.165,7.776a.867.867,0,0,0,.773.938",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M477.209,540.064l.015,0a.869.869,0,0,0,.94-.788c.266-3.038,2.851-6.922,2.877-6.961a.867.867,0,0,0-1.44-.967c-.117.174-2.859,4.291-3.165,7.776A.867.867,0,0,0,477.209,540.064Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M473.287,539.65a.886.886,0,0,0,.235-.007.867.867,0,0,0,.712-1c-.616-3.682,2.8-6.836,2.839-6.867a.867.867,0,0,0-1.162-1.287c-.17.154-4.162,3.812-3.387,8.44a.866.866,0,0,0,.763.719",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M473.287,539.65a.886.886,0,0,0,.235-.007.867.867,0,0,0,.712-1c-.616-3.682,2.8-6.836,2.839-6.867a.867.867,0,0,0-1.162-1.287c-.17.154-4.162,3.812-3.387,8.44A.866.866,0,0,0,473.287,539.65Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M469.028,538.626a.835.835,0,0,0,.285-.018.866.866,0,0,0,.651-1.038c-.754-3.283,2.481-6.992,2.514-7.029a.867.867,0,0,0-1.3-1.15c-.159.178-3.863,4.409-2.907,8.567a.869.869,0,0,0,.754.668",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M469.028,538.626a.835.835,0,0,0,.285-.018.866.866,0,0,0,.651-1.038c-.754-3.283,2.481-6.992,2.514-7.029a.867.867,0,0,0-1.3-1.15c-.159.178-3.863,4.409-2.907,8.567A.869.869,0,0,0,469.028,538.626Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M378.922,532.2l-1.255,3.658s1.6,6.733,11.546,8.854,15.661,4.978,20.462,5.778a41.5,41.5,0,0,0,7.659.686l1.143-1.372Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M378.922,532.2l-1.255,3.658s1.6,6.733,11.546,8.854,15.661,4.978,20.462,5.778a41.5,41.5,0,0,0,7.659.686l1.143-1.372Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M437.343,537.969,418.48,549.8a200.453,200.453,0,0,1-24.585-6.372v-.008c-8.054-2.783-14.971-6.285-14.971-10.082,0-5.774,6.267-6.692,13.5-5.7,1.352.173,2.731.425,4.118.719,11.477,2.471,26.908-2.384,26.908-2.384Z",
    fill: "#4e3057"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M437.343,537.969l-11.1,6.961a44.72,44.72,0,0,1-22.53-15.872,74.885,74.885,0,0,0,19.73-3.087Z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M437.343,537.969,418.48,549.8a200.453,200.453,0,0,1-24.585-6.372v-.008c-8.054-2.783-14.971-6.285-14.971-10.082,0-5.774,6.267-6.692,13.5-5.7,1.352.173,2.731.425,4.118.719,11.477,2.471,26.908-2.384,26.908-2.384Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M393.895,543.422c-8.053-2.783-14.971-6.285-14.971-10.082,0-5.773,6.267-6.692,13.5-5.7.286.338,6.6,7.88,1.474,15.786",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M393.895,543.422c-8.053-2.783-14.971-6.285-14.971-10.082,0-5.773,6.267-6.692,13.5-5.7C392.707,527.974,399.018,535.516,393.895,543.422Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M400.531,536.952l-.05,0a.866.866,0,0,1-.816-.914,11.732,11.732,0,0,0-2.277-6.869.867.867,0,0,1,1.369-1.064,13.316,13.316,0,0,1,2.638,8.031.866.866,0,0,1-.864.818",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M400.531,536.952l-.05,0a.866.866,0,0,1-.816-.914,11.732,11.732,0,0,0-2.277-6.869.867.867,0,0,1,1.369-1.064,13.316,13.316,0,0,1,2.638,8.031A.866.866,0,0,1,400.531,536.952Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M403.961,537.524q-.037,0-.075,0a.866.866,0,0,1-.789-.938,12.836,12.836,0,0,0-1.92-7.1.867.867,0,0,1,1.449-.952,14.39,14.39,0,0,1,2.2,8.2.867.867,0,0,1-.863.793",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M403.961,537.524q-.037,0-.075,0a.866.866,0,0,1-.789-.938,12.836,12.836,0,0,0-1.92-7.1.867.867,0,0,1,1.449-.952,14.39,14.39,0,0,1,2.2,8.2A.867.867,0,0,1,403.961,537.524Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M408.133,537.524h-.015a.868.868,0,0,1-.852-.882c.054-3.049-2.108-7.183-2.13-7.225a.867.867,0,0,1,1.533-.81c.1.186,2.393,4.567,2.331,8.065a.868.868,0,0,1-.867.852",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M408.133,537.524h-.015a.868.868,0,0,1-.852-.882c.054-3.049-2.108-7.183-2.13-7.225a.867.867,0,0,1,1.533-.81c.1.186,2.393,4.567,2.331,8.065A.868.868,0,0,1,408.133,537.524Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M412.077,537.524a.894.894,0,0,1-.233-.031.868.868,0,0,1-.6-1.068c1-3.6-2.071-7.092-2.1-7.127a.867.867,0,0,1,1.291-1.158c.153.171,3.738,4.228,2.482,8.749a.868.868,0,0,1-.835.635",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M412.077,537.524a.894.894,0,0,1-.233-.031.868.868,0,0,1-.6-1.068c1-3.6-2.071-7.092-2.1-7.127a.867.867,0,0,1,1.291-1.158c.153.171,3.738,4.228,2.482,8.749A.868.868,0,0,1,412.077,537.524Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M416.419,536.952a.867.867,0,0,1-.82-1.149c1.1-3.185-1.733-7.213-1.762-7.253a.867.867,0,0,1,1.411-1.008c.139.193,3.378,4.79,1.99,8.825a.866.866,0,0,1-.819.585",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M416.419,536.952a.867.867,0,0,1-.82-1.149c1.1-3.185-1.733-7.213-1.762-7.253a.867.867,0,0,1,1.411-1.008c.139.193,3.378,4.79,1.99,8.825A.866.866,0,0,1,416.419,536.952Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M420.535,541.643c3.087.844-1.043,6.9-5.094,4.5s2.008-5.346,5.094-4.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M420.535,541.643c3.087.844-1.043,6.9-5.094,4.5S417.449,540.8,420.535,541.643Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M384.869,509.508c4.637,6.492,18.362,13.659,32.042,19.575a64.482,64.482,0,0,0,8.578,11.208c8.421,8.662,11.854,3.809,11.854,3.809s5.317-.6,13.173-1.672a3.724,3.724,0,0,0,3.97,2.232c1.022-.162,2.989-1.622,5.207-3.551,19.826-2.985,46.741-7.962,54.008-13.817",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M384.869,509.508c4.637,6.492,18.362,13.659,32.042,19.575a64.482,64.482,0,0,0,8.578,11.208c8.421,8.662,11.854,3.809,11.854,3.809s5.317-.6,13.173-1.672a3.724,3.724,0,0,0,3.97,2.232c1.022-.162,2.989-1.622,5.207-3.551,19.826-2.985,46.741-7.962,54.008-13.817",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M505.928,497.162c-3.429-3.772-6.859-3.944-14.061-3.429,0,0-18.789,5.958-31.893,13.889s-32.237,16.263-32.237,16.263-5.83-1.688-9.886,0c0,0-2.849.221-.94,5.2",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M514.673,519.688s.1,5.81-8.14,9.834",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M423.793,495.447s13.011,9.4,15.6,15.6a53.721,53.721,0,0,1,7.388,3.808",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M440.341,503.263a14.893,14.893,0,0,1,.457,8.409",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M437.343,497.162a23.037,23.037,0,0,1,1.862,3.251",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M455.858,496.3s4.35,5.814,5.433,10.537",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M480.088,531.46a37.63,37.63,0,0,0,4.825-.594",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M439.28,527.292a232.126,232.126,0,0,0,37.4,4.294",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M527.271,439.11s-2.349,40.949-5.118,43.349-7.142,3.087-15.415,3.773-44.848,2.933-44.848,2.933l-3.912-11.753s19.449-1.974,28.081-5.151A145.312,145.312,0,0,1,505.928,467s-1.634-10.313-1.634-14.747V431.373",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M527.271,439.11s-2.349,40.949-5.118,43.349-7.142,3.087-15.415,3.773-44.848,2.933-44.848,2.933l-3.912-11.753s19.449-1.974,28.081-5.151A145.312,145.312,0,0,1,505.928,467s-1.634-10.313-1.634-14.747V431.373",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M520.067,394.323c8.918,5.487,11.548,18.176,8.461,45.268,0,0,2.633,3.2-1.257,4.8,0,0-14.565-5.447-21.343-1.7s-5.019-5.188-5.019-5.188-2.789-24.921,3.385-29.425",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M503.494,404.268s-8.574,8.916-1.029,31.436a36.709,36.709,0,0,0-1.038,5.6c.009,1.5,2.067,2.286,2.067,2.286",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M493.47,419.358s.625,10.974,7.439,15.775",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M495.672,393.818s-13.288,5.092-23.863-.546c-6.268-3.341-3.685-8.713-3.685-8.713",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M400.1,497.181h72.338a19.113,19.113,0,0,0,4.842-.624l14.267-3.743a.924.924,0,0,0-.234-1.818h-94.2a.924.924,0,0,0-.924.924v1.349a3.911,3.911,0,0,0,3.912,3.912",
    fill: "#cbc4ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M400.1,497.181h72.338a19.113,19.113,0,0,0,4.842-.624l14.267-3.743a.924.924,0,0,0-.234-1.818h-94.2a.924.924,0,0,0-.924.924v1.349A3.911,3.911,0,0,0,400.1,497.181Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M392.932,493.586h72.54a1.733,1.733,0,0,0,1.693-2.329l-13.458-52.328a3.19,3.19,0,0,0-2.891-2.329h-72.54a1.733,1.733,0,0,0-1.693,2.329l13.458,52.328a3.189,3.189,0,0,0,2.891,2.329",
    fill: "#eeebef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M392.932,493.586h72.54a1.733,1.733,0,0,0,1.693-2.329l-13.458-52.328a3.19,3.19,0,0,0-2.891-2.329h-72.54a1.733,1.733,0,0,0-1.693,2.329l13.458,52.328A3.189,3.189,0,0,0,392.932,493.586Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x1: 1.372,
    transform: "translate(379.462 438.461)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x1: 7.087,
    transform: "translate(384.379 438.461)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M463.728,486.969,451.852,440.79a3.19,3.19,0,0,0-2.891-2.329H393.066",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x1: 0.297,
    y1: 1.153,
    transform: "translate(464.466 489.843)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M414.764,466.411a7.111,7.111,0,0,0,.253,1.254c.925,3.151,3.876,5.064,6.588,4.266s4.16-4,3.235-7.154-3.886-5.063-6.6-4.265a4.477,4.477,0,0,0-.916.39,5.58,5.58,0,0,1-2.563,5.509",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M414.764,466.411a7.111,7.111,0,0,0,.253,1.254c.925,3.151,3.876,5.064,6.588,4.266s4.16-4,3.235-7.154-3.886-5.063-6.6-4.265a4.477,4.477,0,0,0-.916.39A5.58,5.58,0,0,1,414.764,466.411Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M446.785,368.346c-6.279-.686-9.708-6.65-13.481-7.583a42.122,42.122,0,0,1-6.185-1.991s-1.3-4.545-3.245-2.958-4.514,35.494-2,34.429,2.514,2.936,2.514,2.936L447.7,413.727l19.541-34.6s-14.178-10.093-20.457-10.779",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M450.919,377.513s-5.947,11.17-6.7,28.262",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M433.315,385.254s1.789,9.5,7.026,16.383",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M457.978,424.45s8.984,29.558,28.556,38.265",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M481.632,370.941s-.85,6.45-7.05,6.9a27.47,27.47,0,0,0-2.75-4.61,86.585,86.585,0,0,1,9.8-2.29",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M494.844,371.4s10.37,1.267,14.711-12.652.93-24.411-16.235-29.462c-9.517-2.8-19.034-.547-22.463,6.655-2.941,6.175-1.551,11.3-2.229,13.376-.758,2.315-7.774,4.285-7.774,5.876,0,1.317,3.887,3.555,3.887,3.555L463.6,362.2l1.077.571s-1.992,7.793-1.077,10.536c.669,2.006,18.233,2.839,19.605-2.134",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M494.844,371.4s10.37,1.267,14.711-12.652.93-24.411-16.235-29.462c-9.517-2.8-19.034-.547-22.463,6.655-2.941,6.175-1.551,11.3-2.229,13.376-.758,2.315-7.774,4.285-7.774,5.876,0,1.317,3.887,3.555,3.887,3.555L463.6,362.2l1.077.571s-1.992,7.793-1.077,10.536c.669,2.006,18.233,2.839,19.605-2.134",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M470.943,340.995s3.429.857,4.372,2.658",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M471.551,348.9c-.148,1.007.084,1.875.517,1.939s.9-.7,1.052-1.709-.084-1.875-.517-1.939-.9.7-1.052,1.709",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M464.675,362.772s5.582,2.143,7.661.848",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M466.637,348.1c-.415,2.235.085,4.2,1.117,4.393s2.205-1.464,2.62-3.7-.085-4.2-1.117-4.393S467.052,345.868,466.637,348.1Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M510.009,336.708a16.5,16.5,0,0,0-6.516-10.06,30.509,30.509,0,0,0-12.575-5.144s3.316,1.447,4.573,3.353c0,0-8.573-6.439-18.748-2.21s-8.916,15.223-8.916,15.223l1.486-2.877s-.171,3.43,1.629,4.687a22.566,22.566,0,0,1,2.186-4.8s2.7,8.116,10.131,10.86a5.884,5.884,0,0,1-.114-4s4.113,8.916,2.914,13.26l1.316,2.287s4.729-4.793,8.573-.8c2.209,2.294-4.229,10.975-5.144,10.975l3.887,5.715s9.717,1.385,15.318-9.138,4.23-15.025,4.23-15.025a13.871,13.871,0,0,1,2.057,4.044s1.6-11.317-6.287-16.347",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M487.147,358.314s2.982-10.086,9.379-6.529,1.823,8.93-.462,10.987-4,5.83-5.487,5.83-1.831-1.829-1.831-1.829",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M487.147,358.314s2.982-10.086,9.379-6.529,1.823,8.93-.462,10.987-4,5.83-5.487,5.83-1.831-1.829-1.831-1.829",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 17.802,
    y2: 3.696,
    transform: "translate(470.374 348.797)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M198.087,349.26H186.025V466.168h32.062V369.26a20.059,20.059,0,0,0-20-20",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M198.37,348.32V472.47a20.059,20.059,0,0,1-20,20H20.5a20.059,20.059,0,0,1-20-20V348.32a20.059,20.059,0,0,1,20-20H178.37a20.059,20.059,0,0,1,20,20",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 197.87,
    height: 164.15,
    rx: 20,
    transform: "translate(0.5 328.32)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M25.085,379.567,10.5,411.277v-39.62Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M44.065,338.317l-13.62,29.61-19.95-10.82v-8.79a10.01,10.01,0,0,1,10-10Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M52.705,338.317,10.5,431.337v-4.76l40.61-88.26Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M122.155,338.317l-9.78,10.06-10.91,21.34c-2.59-2.69-6.36-7.65-6.27-13.1a13.608,13.608,0,0,1,1.69-6.5c3.25-6.14,5.05-9.63,6.14-11.8Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M99.195,374.177l-12.61,24.68-36.04-18.97,18.75-41.57h28.36c-1.1,2.14-2.67,5.14-5.01,9.55a18.614,18.614,0,0,0-2.25,8.75c.13,8.58,5.84,14.85,8.8,17.56",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M14.382,460.053l27.1,11.711L75.3,403.756,46.59,388.645Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M106.3,478.267l-.33,4.2H75.745l17.64-10.64,6.58-3.35Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M39.525,476.147l-1.58,6.32H20.5a10,10,0,0,1-10-10v-3.8l1.91-4.24Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M188.365,417.017v37.16l-.14.14-23.41-23.14Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M188.365,376.037v2.06c-.29-.49-.54-.92-.76-1.28Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M110.775,482.467l.43-5.44-6.94-10.73,11.29-5.75c2.6,4.43,4.62,7.91,5.62,9.7a26.056,26.056,0,0,1,3,12.22Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M188.365,369.2l-33.37,34.05,3.41,3.36,25.79-26.15c1,1.7,2.44,4.13,4.17,7.07v20.16l-29.44,17.71-53.8-52.29,11.19-21.9,12.53-12.89h49.52a10.017,10.017,0,0,1,10,10Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M89.535,464.822l21.047-12.692c-3.14-5.3-6.611-11.135-9.978-16.778-7.15-11.992-13.836-23.147-15.953-26.677l-5.106-2.686L45.888,473.67l14.2,6.136Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M154.682,427.948l-51.84-50.378L90.827,401.089l.668.352.692,1.149c.016.033,16.346,27.244,27.634,46.322Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M188.365,461.2v5.45l-4.68,14.28a9.884,9.884,0,0,1-5.32,1.54h-44.59a35.763,35.763,0,0,0-4.22-16.87c-1.05-1.89-3.08-5.39-5.67-9.8l36.69-22.07Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M54.145,482.467H42.9l1.1-4.39Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M62.285,338.317,10.5,453.117V446.8l49.23-108.48Z",
    fill: "#e2dbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M59.725,338.317,10.5,446.8v-15.46l42.21-93.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M183.685,480.927a9.991,9.991,0,0,0,4.68-8.46v-5.82Zm4.68-73.24-29.44,17.71-53.8-52.29,11.19-21.9,12.53-12.89h-6.69l-9.78,10.06-10.91,21.34c-2.59-2.69-6.36-7.65-6.27-13.1a13.608,13.608,0,0,1,1.69-6.5c3.25-6.14,5.05-9.63,6.14-11.8h-5.37c-1.1,2.14-2.67,5.14-5.01,9.55a18.614,18.614,0,0,0-2.25,8.75c.13,8.58,5.84,14.85,8.8,17.56l-12.61,24.68-36.04-18.97,18.75-41.57h-7.01l-51.79,114.8v15.55l1.91-4.24,27.12,11.72-1.58,6.32H42.9l1.1-4.39,10.15,4.39h21.6l17.64-10.64,6.58-3.35,6.33,9.79-.33,4.2h4.81l.43-5.44-6.94-10.73,11.29-5.75c2.6,4.43,4.62,7.91,5.62,9.7a26.056,26.056,0,0,1,3,12.22h9.6a35.763,35.763,0,0,0-4.22-16.87c-1.05-1.89-3.08-5.39-5.67-9.8l36.69-22.07,27.79,27.47v-7.02l-.14.14-23.41-23.14,23.55-14.16Zm-146.89,64.08-27.09-11.71,32.2-71.41,28.72,15.11Zm48.06-6.94-29.45,14.98-14.2-6.14,33.66-67.68,5.11,2.69c2.11,3.53,8.8,14.68,15.95,26.68,3.37,5.64,6.84,11.47,9.98,16.77Zm30.28-15.91c-11.28-19.08-27.61-46.29-27.63-46.33l-.69-1.15-.67-.35,12.02-23.52,51.84,50.38Zm68.55-79.72-33.37,34.05,3.41,3.36,25.79-26.15c1,1.7,2.44,4.13,4.17,7.07V378.1c-.29-.49-.54-.92-.76-1.28l.76-.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M51.105,338.317,10.5,426.577v-15.3l14.59-31.71-14.59-7.91v-14.55l19.95,10.82,13.62-29.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M141.813,319.11a19.658,19.658,0,0,0-19.658,19.658c0,14.037,19.658,29.428,19.658,29.428s19.658-15.391,19.658-29.428a19.658,19.658,0,0,0-19.658-19.658m0,27.677a8.019,8.019,0,1,1,8.019-8.019,8.019,8.019,0,0,1-8.019,8.019",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M39.525,418.289a13.919,13.919,0,0,0-13.919,13.919c0,9.939,13.919,20.837,13.919,20.837s13.919-10.9,13.919-20.837a13.919,13.919,0,0,0-13.919-13.919m0,19.6a5.678,5.678,0,1,1,5.678-5.678,5.678,5.678,0,0,1-5.678,5.678",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M308.67,437.22a5.36,5.36,0,0,0,5.36,5.36v6.71a5.365,5.365,0,0,0,0,10.73v6.15H198.37v6.3a20.059,20.059,0,0,1-20,20H158.35a9.287,9.287,0,0,0-8.62-5.84v-9.16a5.37,5.37,0,1,0,0-10.74v-6.71a5.365,5.365,0,1,0,0-10.73v-6.71a5.365,5.365,0,1,0,0-10.73v-9.17a9.274,9.274,0,0,0,9.28-9.28H304.75a9.28,9.28,0,0,0,9.28,9.28v9.17a5.362,5.362,0,0,0-5.36,5.37",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M295.617,456.376a5.366,5.366,0,0,1,5.366-5.366V444.3a5.366,5.366,0,0,1,0-10.732V426.86a5.366,5.366,0,0,1,0-10.732V406.96a9.28,9.28,0,0,1-9.279-9.28H145.965a9.28,9.28,0,0,1-9.28,9.28v9.168a5.366,5.366,0,1,1,0,10.732v6.709a5.366,5.366,0,1,1,0,10.732v6.709a5.366,5.366,0,1,1,0,10.732v9.168a9.28,9.28,0,0,1,9.28,9.28H291.7a9.28,9.28,0,0,1,9.279-9.28v-9.168a5.366,5.366,0,0,1-5.366-5.366",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M295.617,456.376a5.366,5.366,0,0,1,5.366-5.366V444.3a5.366,5.366,0,0,1,0-10.732V426.86a5.366,5.366,0,0,1,0-10.732V406.96a9.28,9.28,0,0,1-9.279-9.28H145.965a9.28,9.28,0,0,1-9.28,9.28v9.168a5.366,5.366,0,1,1,0,10.732v6.709a5.366,5.366,0,1,1,0,10.732v6.709a5.366,5.366,0,1,1,0,10.732v9.168a9.28,9.28,0,0,1,9.28,9.28H291.7a9.28,9.28,0,0,1,9.279-9.28v-9.168A5.366,5.366,0,0,1,295.617,456.376Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 138.012,
    height: 69.872,
    transform: "translate(149.828 404)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M287.84,472.872v1h-1",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x1: 133.056,
    transform: "translate(151.813 473.872)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1,
    strokeDasharray: "1.971 1.971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M150.828,473.872h-1v-1",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    y1: 64.787,
    transform: "translate(149.828 406.028)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1,
    strokeDasharray: "2.057 2.057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M149.828,405v-1h1",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 133.055,
    transform: "translate(152.799 403.999)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1,
    strokeDasharray: "1.971 1.971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M286.84,404h1v1",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    y2: 64.787,
    transform: "translate(287.84 407.056)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1,
    strokeDasharray: "2.057 2.057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 13.848,
    height: 6.39,
    transform: "translate(187.338 437.838)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M222.182,445.535V451.5H203.475v-1.531c10.122-11.935,11.514-13.863,11.514-16.023a2.126,2.126,0,0,0-2.187-2.278,2.2,2.2,0,0,0-2.272,2.466v.486h-6.649v-.465c0-5.086,3.332-8.447,8.841-8.447,5.334,0,9.017,3.28,9.017,8,0,3.164-1.171,5.594-6.55,11.825Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M225.3,438.954c0-8.055,4.3-13.207,11.009-13.207s11.009,5.152,11.009,13.207c0,8.035-4.324,13.208-11.009,13.208S225.3,446.989,225.3,438.954m15.123.022c0-4.633-1.484-7.238-4.114-7.238-2.648,0-4.114,2.583-4.114,7.216s1.466,7.217,4.114,7.217,4.114-2.561,4.114-7.195",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M249.779,432.145a6.488,6.488,0,1,1,6.486,6.3,6.1,6.1,0,0,1-6.486-6.3m8.4,0a1.91,1.91,0,1,0-3.819,0,1.91,1.91,0,1,0,3.819,0m12.019-5.8h4.964L260,451.5h-4.967Zm-2.562,19.28a6.489,6.489,0,1,1,6.485,6.3,6.107,6.107,0,0,1-6.485-6.3m8.394,0a1.829,1.829,0,0,0-1.909-1.938,1.938,1.938,0,1,0,1.909,1.938",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 29.143,
    height: 69.872,
    transform: "translate(149.828 403.984)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 29.143,
    height: 69.872,
    transform: "translate(149.828 403.984)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    width: 15.921,
    height: 1.952,
    transform: "translate(156.439 411.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_349",
    "data-name": "Rectangle 349",
    width: 15.921,
    height: 3.171,
    transform: "translate(156.439 415.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 15.921,
    height: 3.171,
    transform: "translate(156.439 419.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 15.921,
    height: 3.171,
    transform: "translate(156.439 424.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 15.921,
    height: 3.171,
    transform: "translate(156.439 429.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 15.921,
    height: 3.171,
    transform: "translate(156.439 433.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 15.921,
    height: 3.171,
    transform: "translate(156.439 437.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 15.921,
    height: 1.835,
    transform: "translate(156.439 443.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 15.921,
    height: 1.835,
    transform: "translate(156.439 446.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 15.921,
    height: 1.835,
    transform: "translate(156.439 452.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 15.921,
    height: 1.835,
    transform: "translate(156.439 458.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 15.921,
    height: 1.835,
    transform: "translate(156.439 462.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 15.921,
    height: 1.835,
    transform: "translate(156.439 464.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M304.269,110.28v42.16c0,10.64,9.58,19.36,21.3,19.36h160.8c11.72,0,21.31-8.72,21.31-19.36V110.28Z",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M488.9,81.735v57.08c0,10.64-9.59,19.36-21.31,19.36h-160.8c-11.72,0-21.3-8.72-21.3-19.36V81.735c0-10.65,9.58-19.35,21.3-19.35h160.8c11.72,0,21.31,8.7,21.31,19.35",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M488.9,81.735v57.08c0,10.64-9.59,19.36-21.31,19.36h-160.8c-11.72,0-21.3-8.72-21.3-19.36V81.735c0-10.65,9.58-19.35,21.3-19.35h160.8C479.311,62.385,488.9,71.085,488.9,81.735Z",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M308.124,112.912h-1.876a.761.761,0,0,1-.761-.76h0v-9.126a.761.761,0,0,1,.761-.761h1.876a.761.761,0,0,1,.761.761v9.126A.761.761,0,0,1,308.124,112.912Z",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M330.5,104.638a1.837,1.837,0,0,0-1.868.057l-2.784,1.763a3.3,3.3,0,0,1-3.273,2.9h-3.781a.775.775,0,0,1-.781-.724.76.76,0,0,1,.723-.8h3.839a1.777,1.777,0,0,0,1.773-1.78v-.037a1.8,1.8,0,0,0-1.808-1.732h-4.276l-.5-.373a5.746,5.746,0,0,0-6.4-.33l-.954.576V111.9h12.783a3.8,3.8,0,0,0,2.084-.619l5.346-3.5a1.836,1.836,0,0,0-.12-3.145Z",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M316.237,86.952a6.338,6.338,0,1,0,6.338,6.338,6.338,6.338,0,0,0-6.338-6.338m.76,9.485v.149a.76.76,0,0,1-1.521,0v-.15a2.031,2.031,0,0,1-1.227-1.474.761.761,0,0,1,1.491-.3.507.507,0,1,0,.5-.609,2.028,2.028,0,0,1-.761-3.908v-.149a.76.76,0,1,1,1.521,0v.149a2.036,2.036,0,0,1,1.227,1.474.761.761,0,0,1-1.491.3.507.507,0,1,0-.5.609,2.027,2.027,0,0,1,.76,3.907Z",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M331.376,97.183a.761.761,0,0,0-.686-.438h-1.107a12.975,12.975,0,0,0-7.575-8.787,7.851,7.851,0,0,1,1.871,7.166,8.437,8.437,0,0,1,.886,1.62H324.1a.76.76,0,0,0-.584,1.248l3.3,3.955a.761.761,0,0,0,1.071.1.906.906,0,0,0,.1-.1l3.3-3.955a.762.762,0,0,0,.1-.809",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M305.906,129.309a4.289,4.289,0,0,1,4.549-4.357,4.182,4.182,0,0,1,4.354,3.644H312.05a1.668,1.668,0,0,0-1.6-1.106,1.7,1.7,0,0,0-1.7,1.828,1.719,1.719,0,0,0,1.7,1.845,1.656,1.656,0,0,0,1.609-1.2h2.784a4.267,4.267,0,0,1-4.393,3.739,4.319,4.319,0,0,1-4.541-4.393",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M324.816,125.2v8.223h-2.19l-.242-.581a3.9,3.9,0,0,1-2.482.86,4.375,4.375,0,0,1,0-8.749,3.9,3.9,0,0,1,2.513.884l.29-.637Zm-2.694,4.118a1.841,1.841,0,1,0-1.841,1.876,1.806,1.806,0,0,0,1.841-1.876",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M329.772,133.7c-2.242,0-3.6-1.184-3.63-2.966h2.726a.849.849,0,0,0,.956.879c.414,0,.808-.212.808-.637,0-.474-.623-.609-1.413-.74-1.275-.207-2.965-.592-2.965-2.586,0-1.648,1.4-2.713,3.512-2.713s3.45,1.115,3.483,2.781H330.6c0-.525-.353-.769-.867-.769-.453,0-.759.225-.759.605,0,.468.629.578,1.41.717,1.3.231,3.028.5,3.028,2.586C333.408,132.577,331.957,133.7,329.772,133.7Z",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M342.858,128.48v4.952h-2.833v-4.623c0-.948-.333-1.432-1.072-1.432-.857,0-1.391.609-1.391,1.664v4.391H334.73V122.24h2.832v3.51a3.509,3.509,0,0,1,2.195-.785c1.888,0,3.1,1.384,3.1,3.515",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M349.395,124.952a4.375,4.375,0,0,1,0,8.75,3.821,3.821,0,0,1-2.481-.88l-.267.61h-2.1V122.24h2.8v3.279a3.855,3.855,0,0,1,2.043-.566Zm1.462,4.375a1.841,1.841,0,1,0-1.841,1.867,1.808,1.808,0,0,0,1.841-1.867",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M363.765,125.2v8.223h-2.189l-.243-.581a3.9,3.9,0,0,1-2.482.86,4.375,4.375,0,0,1,0-8.749,3.9,3.9,0,0,1,2.513.884l.29-.637Zm-2.694,4.118a1.841,1.841,0,1,0-1.841,1.876,1.805,1.805,0,0,0,1.841-1.876",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M369.618,133.7a4.378,4.378,0,1,1,.008-8.75,4.182,4.182,0,0,1,4.354,3.645h-2.758a1.672,1.672,0,0,0-1.6-1.107,1.7,1.7,0,0,0-1.7,1.828,1.72,1.72,0,0,0,1.7,1.846,1.657,1.657,0,0,0,1.61-1.2h2.784a4.267,4.267,0,0,1-4.394,3.738Z",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M380.249,133.432l-2.06-3.478v3.478h-2.833V122.24h2.833v6.19l1.958-3.222h3.181l-2.562,3.92,2.822,4.3Z",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M389.508,86.485v10.76h7.04v36.72h12.79V86.485Z",
    transform: "translate(-3)",
    fill: "rgba(78,48,87,0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M437.868,85.345c-12.66,0-20.79,9.73-20.79,24.94,0,15.16,8.17,24.93,20.79,24.93s20.78-9.77,20.78-24.93c0-15.21-8.12-24.94-20.78-24.94m0,38.56c-5,0-7.77-4.88-7.77-13.62s2.77-13.63,7.77-13.63c4.96,0,7.76,4.92,7.76,13.67s-2.76,13.58-7.76,13.58",
    transform: "translate(-3)",
    fill: "rgba(78,48,87,0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M484.988,96.655a6.947,6.947,0,0,1,1.23.11V85.375q-.6-.03-1.23-.03c-12.66,0-20.78,9.73-20.78,24.94,0,15.16,8.16,24.93,20.78,24.93q.63,0,1.23-.03v-11.39a6.947,6.947,0,0,1-1.23.11c-5,0-7.77-4.88-7.77-13.62s2.77-13.63,7.77-13.63",
    transform: "translate(-3)",
    fill: "rgba(78,48,87,0.25)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1167);
export default __webpack_public_path__ + "static/media/Group_1167.09bda2db648dad8151f7a74957099b01.svg";
export { ForwardRef as ReactComponent };